import { render, staticRenderFns } from "./AddPayments.vue?vue&type=template&id=fcbcde6a&scoped=true"
import script from "./AddPayments.vue?vue&type=script&lang=js"
export * from "./AddPayments.vue?vue&type=script&lang=js"
import style0 from "./AddPayments.vue?vue&type=style&index=0&id=fcbcde6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbcde6a",
  null
  
)

export default component.exports